import { render } from "./RecoverPassword.vue?vue&type=template&id=b002e362&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import "./RecoverPassword.vue?vue&type=style&index=0&id=b002e362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b002e362"]])

export default __exports__